import React, { PropsWithChildren } from 'react';
import { IconChevronLeft12, UIHeading4 } from '@cian/ui-kit';

import styles from './styles.css';

export interface IHeaderProps extends PropsWithChildren {
  rightSlot: React.ReactNode;
  onExitClick?: () => void;
}

export const Header: React.FC<IHeaderProps> = ({ rightSlot, onExitClick, children }) => {
  return (
    <div className={styles.root} data-testid="form-header">
      <div className={styles.top_content}>
        <div className={styles.left_button}>
          <span className={styles.arrow_icon}>
            <IconChevronLeft12 color="primary_100" />
          </span>
          <UIHeading4 onClick={onExitClick} color="primary_100">
            <a className={styles.link} href="https://my.cian.ru/ipoteka-partner/requests/?cian_source=calculator">
              К списку заявок
            </a>
          </UIHeading4>
        </div>
        <div className={styles.right_slot}>{rightSlot}</div>
      </div>
      <div className={styles.bottom_content}>{children}</div>
    </div>
  );
};

Header.displayName = 'Header';
